var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['user-layout-wrapper', _vm.device],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"container"},[_c('route-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }